(() => {
  const roots = document.querySelectorAll('[data-cara-lp-hero]');

  roots.forEach((root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const store = window.CaraLpSelection;
    if (!store) {
      console.warn('CaraLpSelection store is missing.');
      return;
    }

    const colorButtons = Array.from(root.querySelectorAll('[data-cara-color]'));
    const image = root.querySelector('[data-cara-product-image]');
    const title = root.querySelector('[data-cara-product-title]');
    const price = root.querySelector('[data-cara-product-price]');
    const compare = root.querySelector('[data-cara-product-compare]');
    const colorLabel = root.querySelector('[data-cara-color-label]');
    const sizeLabel = root.querySelector('[data-cara-size-label]');
    const sizeList = root.querySelector('[data-cara-size-list]');
    const productForm = root.querySelector('form[is="product-form"], .cara-lp-buybox__form');
    const variantInput = root.querySelector('[data-cara-variant-id]');
    const quantityInput = root.querySelector('[name="quantity"]');
    const quantitySelector = root.querySelector('quantity-selector');
    const decreaseButton = quantitySelector?.querySelector('button:first-of-type') || null;
    const increaseButton = quantitySelector?.querySelector('button:last-of-type') || null;
    const addButton = root.querySelector('[data-cara-add]');
    const addLabel = root.querySelector('[data-cara-add-label]');
    const status = root.querySelector('[data-cara-product-status]');
    const buttonLabel = root.dataset.buttonLabel || 'Add to cart';
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    const seedProducts = {};
    root.querySelectorAll('[data-cara-product-json]').forEach((script) => {
      try {
        seedProducts[script.dataset.caraProductJson] = JSON.parse(script.textContent);
      } catch (error) {
        console.warn('Cara landing product JSON could not be parsed.', error);
      }
    });

    const colors = colorButtons.map((button) => ({
      handle: button.dataset.productHandle || '',
      colorName: button.dataset.colorName || '',
      customImage: button.dataset.customImage || '',
      swatch: button.querySelector('.cara-lp-color__swatch')?.style?.getPropertyValue('--swatch')?.trim() || ''
    })).filter((item) => item.handle);

    let applyingSnapshot = false;
    let lastHandle = '';
    let lastSelectionKey = '';
    let selectedAvailable = true;

    function setStatus(message, type = '') {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-warning', type === 'warning');
      status.classList.toggle('is-error', type === 'error');
    }

    function clearStatus() {
      setStatus('');
    }

    function restoreSubmitButton() {
      requestAnimationFrame(() => {
        if (addButton) addButton.disabled = !selectedAvailable;
      });
    }

    function getInputMax() {
      if (!quantityInput) return null;
      const maxAttr = quantityInput.getAttribute('max');
      if (maxAttr === null || maxAttr === '') return null;
      const parsed = Number(maxAttr);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    }

    function showMaxReachedFeedback(limit) {
      if (limit === 1) {
        setStatus('Only 1 left in stock.', 'warning');
      } else {
        setStatus('Maximum available quantity reached.', 'warning');
      }
    }

    function syncQuantityButtons() {
      if (!quantityInput) return;
      const current = Number(quantityInput.value) || 1;
      const inputMax = getInputMax();
      const min = Number(quantityInput.min) || 1;

      if (decreaseButton) {
        const atMin = current <= min;
        decreaseButton.disabled = atMin;
        decreaseButton.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      }

      if (increaseButton) {
        const atMax = inputMax !== null && current >= inputMax;
        increaseButton.disabled = false;
        increaseButton.classList.toggle('is-at-max', atMax);
        increaseButton.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      }
    }

    function applyQuantityMax(nextMax) {
      if (!quantityInput) return;
      if (typeof nextMax === 'number' && nextMax > 0) {
        quantityInput.setAttribute('max', String(nextMax));
      } else {
        quantityInput.removeAttribute('max');
      }
      syncQuantityButtons();
    }

    function setImage(src) {
      if (!image || !src) return;
      image.src = src;
      image.removeAttribute('srcset');
    }

    function setColorButtonsDisabled(disabled) {
      colorButtons.forEach((button) => {
        button.disabled = disabled;
      });
    }

    function renderSizes(product, activeVariantId) {
      if (!sizeList || !product) return;
      sizeList.innerHTML = '';

      product.variants.forEach((variant) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cara-lp-size';
        button.dataset.caraSize = variant.id;
        button.textContent = variant.title;
        button.disabled = !variant.available;
        if (String(variant.id) === String(activeVariantId)) {
          button.classList.add('is-active');
        }
        button.addEventListener('click', () => {
          clearStatus();
          store.setSize(variant.id);
        });
        sizeList.appendChild(button);
      });
    }

    function applyLowStockTip(snapshot) {
      const variant = snapshot.variant;
      if (!variant?.available) return;
      if (status?.classList.contains('is-error')) return;

      const inventoryQty = store.normalizeInventoryQuantity(variant.inventory_quantity);
      if (
        inventoryQty === null
        || !variant.inventory_management
        || variant.inventory_policy === 'continue'
      ) {
        return;
      }

      const remaining = typeof snapshot.max === 'number' ? snapshot.max : inventoryQty;
      if (remaining > 0 && remaining <= 5) {
        setStatus(
          remaining === 1 ? 'Only 1 left in stock.' : `Only ${remaining} left in this size.`,
          'warning'
        );
      }
    }

    function applySnapshot(snapshot) {
      if (!snapshot?.ready) return;
      applyingSnapshot = true;

      try {
        const product = snapshot.product;
        const variant = snapshot.variant;
        selectedAvailable = Boolean(snapshot.available);

        colorButtons.forEach((button) => {
          const active = button.dataset.productHandle === snapshot.handle;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active && colorLabel) {
            colorLabel.textContent = button.dataset.colorName || '';
          }
        });

        if (product && title) title.textContent = product.title;

        if (product && lastHandle !== snapshot.handle) {
          renderSizes(product, snapshot.variantId);
          lastHandle = snapshot.handle;
        } else if (sizeList) {
          sizeList.querySelectorAll('[data-cara-size]').forEach((button) => {
            button.classList.toggle(
              'is-active',
              String(button.dataset.caraSize) === String(snapshot.variantId)
            );
          });
        }

        if (variantInput && snapshot.variantId != null) {
          variantInput.value = snapshot.variantId;
        }

        if (variant) {
          if (price) price.textContent = variant.price;
          if (compare) {
            compare.textContent = variant.compare_price || '';
            compare.hidden = !variant.compare_price;
          }
          if (sizeLabel) sizeLabel.textContent = variant.title;
        }

        const customImage = colors.find((item) => item.handle === snapshot.handle)?.customImage || '';
        if (customImage) {
          setImage(customImage);
        } else if (variant?.image) {
          setImage(variant.image);
        } else if (product?.featured_image) {
          setImage(product.featured_image);
        }

        if (quantityInput) {
          if ('quantity' in quantityInput) {
            quantityInput.quantity = snapshot.qty;
          } else {
            quantityInput.value = String(snapshot.qty);
          }
        }
        applyQuantityMax(snapshot.max);

        if (addButton && productForm?.getAttribute('aria-busy') !== 'true') {
          addButton.disabled = !selectedAvailable;
        }
        if (addLabel) {
          addLabel.textContent = selectedAvailable ? buttonLabel : 'Sold out';
        }

        const selectionKey = `${snapshot.handle}:${snapshot.variantId}`;
        if (selectionKey !== lastSelectionKey) {
          lastSelectionKey = selectionKey;
          if (variant && !variant.available) {
            setStatus('This size is currently unavailable.', 'error');
          } else {
            clearStatus();
            applyLowStockTip(snapshot);
          }
        } else if (variant?.available && !status?.classList.contains('is-error')) {
          applyLowStockTip(snapshot);
        }
      } finally {
        applyingSnapshot = false;
      }
    }

    increaseButton?.addEventListener(
      'click',
      (event) => {
        const inputMax = getInputMax();
        const current = Number(quantityInput?.value) || 1;
        if (inputMax !== null && current >= inputMax) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showMaxReachedFeedback(inputMax);
          syncQuantityButtons();
        }
      },
      true
    );

    increaseButton?.addEventListener('click', () => {
      window.setTimeout(() => {
        if (applyingSnapshot) return;
        const next = Number(quantityInput?.value) || 1;
        store.setQty(next);
        const inputMax = getInputMax();
        if (inputMax !== null && next >= inputMax) showMaxReachedFeedback(inputMax);
        syncQuantityButtons();
      }, 0);
    });

    decreaseButton?.addEventListener('click', () => {
      window.setTimeout(() => {
        if (applyingSnapshot) return;
        const next = Number(quantityInput?.value) || 1;
        store.setQty(next);
        syncQuantityButtons();
        const inputMax = getInputMax();
        const current = Number(quantityInput?.value) || 1;
        if (
          inputMax !== null
          && current < inputMax
          && inputMax <= 5
          && status
          && !status.classList.contains('is-error')
        ) {
          setStatus(
            inputMax === 1 ? 'Only 1 left in stock.' : `Only ${inputMax} left in this size.`,
            'warning'
          );
        }
      }, 0);
    });

    quantityInput?.addEventListener('change', () => {
      if (applyingSnapshot) return;
      const next = Number(quantityInput.value) || 1;
      store.setQty(next);
      const inputMax = getInputMax();
      if (inputMax !== null && next >= inputMax) showMaxReachedFeedback(inputMax);
      syncQuantityButtons();
    });

    productForm?.addEventListener('cart:error', (event) => {
      const message = event.detail?.error || 'Unable to add to cart.';
      setStatus(message, event.detail?.partial ? 'warning' : 'error');
      restoreSubmitButton();
      store.syncCartMax({ refreshCart: true });
    });

    productForm?.addEventListener('variant:add', () => {
      clearStatus();
      restoreSubmitButton();
      store.syncCartMax({ refreshCart: true });
    });

    colorButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        clearStatus();
        setColorButtonsDisabled(true);
        setStatus('Loading options…');
        try {
          await store.setColor(button.dataset.productHandle);
        } catch (error) {
          console.warn('Cara landing product could not be loaded.', error);
          setStatus('Unable to load this color. Please try again.', 'error');
        } finally {
          setColorButtonsDisabled(false);
        }
      });
    });

    store.subscribe(applySnapshot);

    async function boot() {
      const urlVariantId = new URL(window.location.href).searchParams.get('variant');
      let defaultHandle = root.dataset.defaultHandle || colors[0]?.handle || '';
      let defaultVariantId = null;

      if (urlVariantId) {
        const cachedMatch = Object.values(seedProducts).find((product) =>
          product.variants.some((variant) => String(variant.id) === String(urlVariantId))
        );

        if (cachedMatch) {
          defaultHandle = cachedMatch.handle;
          defaultVariantId = urlVariantId;
        } else {
          for (const color of colors) {
            try {
              const product = await store.loadProduct(color.handle);
              const match = product?.variants.find(
                (variant) => String(variant.id) === String(urlVariantId)
              );
              if (match) {
                defaultHandle = product.handle;
                defaultVariantId = match.id;
                break;
              }
            } catch (error) {
              console.warn('Cara landing variant lookup failed for', color.handle, error);
            }
          }
        }
      }

      await store.init({
        moneyFormat,
        buttonLabel,
        colors,
        products: seedProducts,
        defaultHandle,
        defaultVariantId
      });
    }

    boot();
  });
})();
